import { HttpParams } from "@angular/common/http";
import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { Clinic } from "src/app/models/clinic.model";
import { ClinicFilters } from "src/app/models/doctor/clinic-filters.model";
import { ClinicService } from "src/app/sections/clinics/services/clinic.service";
import { AuxillaryService } from "src/app/sections/common/services/auxillary.service";
import { CommonUIService } from "src/app/sections/common/services/common.ui.service";

@Component({
  selector: "app-select-clinic",
  templateUrl: "./select-clinic.component.html",
  styleUrls: ["./select-clinic.component.scss"],
})
export class SelectClinicComponent implements OnInit {
  @ViewChild("modalLargeSelectNewClinic", { static: false }) child;
  @Output() close: EventEmitter<any> = new EventEmitter();

  provinceControl = new UntypedFormControl();
  townControl = new UntypedFormControl();

  provinceList: any[];
  townList: any[];
  clinics: Clinic[] = [];

  clinicFilters: ClinicFilters = null;
  isLoading = false;
  selectedClinicId: number = 0;

  page = 1;
  pageSize = 20;
  maxSize = 10;
  totalCount = 0;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _clinicService: ClinicService,
    private _auxillaryService: AuxillaryService,
    private _toastService: ToastrService,
    private _translationService: TranslateService,
    private _router: Router,
    private _commonUIService: CommonUIService
  ) {
    this.provinceList = [];
    this.townList = [];
    this.selectedClinicId = 0;
  }

  ngOnInit() {
    this.initializDropdowns();
    this.selectedClinicId = 0;
    this.isLoading = false;
    this.provinceList = [];
    this.townList = [];

    this.clinicFilters = new ClinicFilters();
    this.clinicFilters.provinceId = null;
    this.clinicFilters.townId = null;
    this.clinicFilters.telephone = "";
    this.clinicFilters.address = "";

    this.provinceControl.setValue(null);
    this.townControl.setValue(null);
  }

  public show(status): void {
    this.clearForm();
    this.child.show();
  }

  async initializDropdowns() {
    this.getTownList();
    this.getProvinceList();
  }

  clearForm() {
    this.selectedClinicId = 0;
    this.clinicFilters = null;
    this.clinicFilters = new ClinicFilters();

    this.clinicFilters.provinceId = null;
    this.clinicFilters.townId = null;
    this.clinicFilters.telephone = "";
    this.clinicFilters.address = "";

    this.provinceControl.setValue(null);
    this.townControl.setValue(null);
    this.clearPagination();
  }

  getTownList() {
    this._auxillaryService.getTownList().subscribe(
      (data: any) => {
        this.townList = data._data.filter((x) => x.status);
      },
      (error) => {}
    );
  }

  getProvinceList() {
    this._auxillaryService.getProvinceList().subscribe(
      (data: any) => {
        if (data._data != null) {
          this.provinceList = data._data.filter((x) => x.status);
        }
      },
      (error) => {}
    );
  }

  OnChangeTown(town) {
    if (town) {
      this.clinicFilters.townId = Number(town.id);
    }
  }

  OnChangeProvince(province) {
    if (province) {
      this.clinicFilters.provinceId = Number(province.id);
    }
  }

  onClear(field) {
    if (field == "town") {
      this.townControl.setValue(null);
      this.clinicFilters.townId = null;
    } else if (field == "province") {
      this.provinceControl.setValue(null);
      this.clinicFilters.provinceId = null;
    }
  }

  searchClinic() {
    this.getClinicList();
  }

  getClinicList() {
    this.isLoading = true;
    this.selectedClinicId = 0;
    
    this._clinicService.getClinicsPaginated(this.pageSize, this.page, this.clinicFilters).subscribe(
      (data: any) => {
        if (data._data) {
          this.clinics = data._data;
          this.totalCount = data.totalCount;
          this.isLoading = false;
        }
      },
      (error) => {
        this.isLoading = false;
       this.clearPagination();   
      }
    );
  }

  clearPagination(){
    this.page = 1;
    this.pageSize = 20;
    this.maxSize = 10;
    this.totalCount = 0;
    this.clinics = [];
  }

  selectClinic(clinic: Clinic) {
    this.selectedClinicId = clinic.id;
  }

  accept(){
    if (this.selectedClinicId > 0) {
      this.close.emit(this.selectedClinicId);
      this.child.hide();
    }
  }
}
